import { globalURL, fetchApiHeaders } from "../../app/constants/constants";
import { checkFormFields } from "../../app/helpers/functions";

const toggleModal = (show, process) => dispatch => {
    dispatch({
        type: "TOGGLE_FEEDBACK_MODAL",
        payload: {
            show: show,
            process: process
        }
    });

    if (!show) {
        dispatch({
            type: "SET_TABLE_ROW_DATA",
            payload: {
                row: null,
                rowIndex: 0
            }
        })
    }
}


const setValue = (key, value) => dispatch => {
    dispatch({
        type: "SET_VALUE_FEEDBACK",
        payload: {
            key: key,
            value: value
        }
    })
}

const getAll = (token) => dispatch => {
    dispatch({
        type: "GET_ALL_FEEDBACKS"
    })
    fetch(globalURL + "/feedback/getAll", {
        method: 'POST',
        headers: {
            ...fetchApiHeaders.POST,
            token: token
        }
    })
        .then((result) => result.json())
        .then(async (feedbacks) => {
            if (feedbacks.success) {
                dispatch({
                    type: "FETCH_ALL_FEEDBACKS",
                    payload: feedbacks.data
                })
            } else {
                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: "İşlem gerçekleştirilirken bir hata oluştu.",
                        type: "error"
                    }
                });

                dispatch({
                    type: "ERROR_ALL_FEEDBACKS",
                    payload: feedbacks
                })
            }
        })
        .catch((error) => {
            dispatch({
                type: "TOGGLE_APP_ALERT",
                payload: {
                    show: true,
                    message: "İşlem gerçekleştirilirken bir hata oluştu.",
                    type: "error"
                }
            });

            dispatch({
                type: "ERROR_ALL_FEEDBACKS",
                payload: error
            })
        })
}

const createNew = (token, data) => dispatch => {
    dispatch({
        type: "GET_INSERT_FEEDBACKS"
    })

    var checkForm = checkFormFields(data, false);
    if (!checkForm.result) {
        fetch(globalURL + "/feedback/create", {
            method: 'POST',
            headers: {
                ...fetchApiHeaders.POST,
                token: token
            },
            body: JSON.stringify({
                name: data[0].value,
                code: data[1].value
            })
        })
            .then((result) => result.json())
            .then(async (insert) => {
                if (insert.success) {
                    dispatch({
                        type: "FETCH_INSERT_FEEDBACKS",
                        payload: insert
                    });
                    dispatch({
                        type: "TOGGLE_APP_ALERT",
                        payload: {
                            show: true,
                            message: data[0].value + " talebi başarıyla oluşturuldu",
                            type: "success"
                        }
                    });
                } else {
                    if (insert.field) {
                        dispatch({
                            type: "SET_VALUE_ERROR_FEEDBACK",
                            payload: {
                                key: insert.field,
                                helpertext: insert.errorMessage
                            }
                        })
                    } else {
                        dispatch({
                            type: "TOGGLE_APP_ALERT",
                            payload: {
                                show: true,
                                message: "İşlem gerçekleştirilirken bir hata oluştu.",
                                type: "error"
                            }
                        })
                    }
                    dispatch({
                        type: "ERROR_INSERT_FEEDBACKS",
                        payload: insert
                    })
                }
            })
            .catch((error) => {
                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: "İşlem gerçekleştirilirken bir hata oluştu.",
                        type: "error"
                    }
                })
                dispatch({
                    type: "ERROR_INSERT_FEEDBACKS",
                    payload: error
                })
            })
    } else {
        checkForm.nullFields.map((item, index) => {
            return dispatch({
                type: "SET_VALUE_ERROR_FEEDBACK",
                payload: {
                    ...item,
                    helpertext: item.helperText
                }
            })
        })
    }
}

const tableActions = (process, id, token) => dispatch => {
    if (process === "update") {
        dispatch({
            type: "GET_DETAIL_FEEDBACK"
        })
        fetch(globalURL + "/feedback/getDetail", {
            method: 'POST',
            headers: {
                ...fetchApiHeaders.POST,
                token: token
            },
            body: JSON.stringify({
                id: id
            })
        })
            .then((result) => result.json())
            .then(async (detail) => {
                console.log(detail)
                if (detail.success) {
                    dispatch({
                        type: "FETCH_DETAIL_FEEDBACK",
                        payload: detail
                    })
                    dispatch({
                        type: "TOGGLE_FEEDBACK_MODAL",
                        payload: {
                            show: true,
                            process: process
                        }
                    })
                } else {
                    dispatch({
                        type: "TOGGLE_APP_ALERT",
                        payload: {
                            show: true,
                            message: "İşlem gerçekleştirilirken bir hata oluştu.",
                            type: "error"
                        }
                    });

                    dispatch({
                        type: "ERROR_DETAIL_FEEDBACK",
                        payload: detail
                    })
                }
            })
            .catch((error) => {
                console.log(error)
                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: "İşlem gerçekleştirilirken bir hata oluştu.",
                        type: "error"
                    }
                });
                dispatch({
                    type: "ERROR_DETAIL_FEEDBACK",
                    payload: error
                })
            })
    } else {
        dispatch({
            type: "TOGGLE_FEEDBACK_MODAL",
            payload: {
                show: true,
                process: process
            }
        })
    }
}

const update = (token, id, data, rowIndex) => dispatch => {
    dispatch({
        type: "GET_UPDATE_FEEDBACK"
    });

    // update
    fetch(globalURL + "/feedback/update", {
        method: 'POST',
        headers: {
            ...fetchApiHeaders.POST,
            token: token
        },
        body: JSON.stringify({
            id: id,
            name: data.name,
            surname: data.surname,
            state: data.feedBackState,
        })
    })
        .then((result) => result.json())
        .then(async (update) => {
            if (update.success) {
                dispatch({
                    type: "FETCH_UPDATE_FEEDBACK",
                    payload: update,
                    rowIndex: rowIndex
                });

                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: data.name + " talep durumu güncellendi.",
                        type: "success"
                    }
                });
            } else {
                if (update.field) {
                    dispatch({
                        type: "SET_VALUE_ERROR_FEEDBACK",
                        payload: {
                            key: update.field,
                            helpertext: update.errorMessage
                        }
                    })
                } else {
                    dispatch({
                        type: "TOGGLE_APP_ALERT",
                        payload: {
                            show: true,
                            message: "İşlem gerçekleştirilirken bir hata oluştu.",
                            type: "error"
                        }
                    });
                }
                dispatch({
                    type: "ERROR_UPDATE_FEEDBACK",
                    payload: update
                })
            }
        })
        .catch((error) => {
            console.log(error)
            dispatch({
                type: "TOGGLE_APP_ALERT",
                payload: {
                    show: true,
                    message: "İşlem gerçekleştirilirken bir hata oluştu.",
                    type: "error"
                }
            });

            dispatch({
                type: "ERROR_UPDATE_FEEDBACK",
                payload: error
            })
        })
}

const deleteEntity = (token, row, rowIndex) => dispatch => {
    dispatch({
        type: "GET_DELETE_FEEDBACK"
    })
    fetch(globalURL + "/feedback/delete", {
        method: 'POST',
        headers: {
            ...fetchApiHeaders.POST,
            token: token
        },
        body: JSON.stringify({
            id: row.id,
            name: row.name,
            surname : row.surname
        })
    })
        .then((result) => result.json())
        .then(async (deleteRecord) => {
            if (deleteRecord.success) {
                dispatch({
                    type: "FETCH_DELETE_FEEDBACK",
                    payload: deleteRecord,
                    rowIndex: rowIndex
                });

                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: "İşlem başarıyla gerçekleşti.",
                        type: "success"
                    }
                });
            } else {
                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: "İşlem gerçekleştirilirken bir hata oluştu.",
                        type: "error"
                    }
                });

                dispatch({
                    type: "ERROR_DELETE_FEEDBACK",
                    payload: deleteRecord
                })
            }
        })
        .catch((error) => {
            dispatch({
                type: "TOGGLE_APP_ALERT",
                payload: {
                    show: true,
                    message: "İşlem gerçekleştirilirken bir hata oluştu.",
                    type: "error"
                }
            });
            dispatch({
                type: "ERROR_DELETE_FEEDBACK",
                payload: error
            })
        })
}



export {
    toggleModal,
    setValue,
    getAll,
    createNew,
    update,
    tableActions,
    deleteEntity
}